import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Track } from "store/track/track.model";

export type RepeatMode = "one" | "all" | "off";

interface PlayerState {
  currentTrack: Track | null;
  currentTrackIndex: number | null;
  queue: Track[];
  isPlaying: boolean;
  progress: number;
  duration: number;
  backgroundColor: string;
  isShuffle: boolean;
  repeatMode: RepeatMode;
}

const initialState: PlayerState = {
  currentTrack: null,
  currentTrackIndex: null,
  queue: [],
  isPlaying: false,
  progress: 0,
  duration: 60,
  backgroundColor: "#424242",
  isShuffle: false,
  repeatMode: "off",
};

export const playerSlice = createSlice({
  name: "player",
  initialState,
  reducers: {
    setCurrentTrack: (
      state,
      action: PayloadAction<PlayerState["currentTrack"]>
    ) => {
      state.currentTrack = action.payload;
    },
    setCurrentTrackIndex: (
      state,
      action: PayloadAction<PlayerState["currentTrackIndex"]>
    ) => {
      state.currentTrackIndex = action.payload;
    },
    setQueue: (state, action: PayloadAction<PlayerState["queue"]>) => {
      state.queue = action.payload;
    },
    setIsPlaying: (state, action: PayloadAction<PlayerState["isPlaying"]>) => {
      state.isPlaying = action.payload;
    },
    setProgress(state, action: PayloadAction<PlayerState["progress"]>) {
      state.progress = action.payload;
    },
    setDuration(state, action: PayloadAction<PlayerState["duration"]>) {
      state.duration = action.payload;
    },
    setBackgroundColor(
      state,
      action: PayloadAction<PlayerState["backgroundColor"]>
    ) {
      state.backgroundColor = action.payload;
    },
    setIsShuffle(state, action: PayloadAction<PlayerState["isShuffle"]>) {
      state.isShuffle = action.payload;
    },
    setRepeatMode(state, action: PayloadAction<PlayerState["repeatMode"]>) {
      state.repeatMode = action.payload;
    },
    removeTrackFromQueue(state, action: PayloadAction<{ trackId: string }>) {
      state.queue = state.queue.filter(
        (track: Track) => track.id !== action.payload.trackId
      );
    },
    reset() {
      return initialState;
    },
  },
});

export const { reducer: playerReducer, actions: playerActions } = playerSlice;
